import { render } from "./login.vue?vue&type=template&id=10ad2f30&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=10ad2f30&lang=scss&scoped=true"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ad2f30"]])

export default __exports__